import React from "react";
import { IonCol, IonGrid, IonIcon, IonLabel, IonRow } from "@ionic/react";
import { basketOutline, removeOutline, addOutline } from "ionicons/icons";
import styles from "./MainPageProduct.module.scss";
import classNames from "classnames/bind";
import { Product, ProductType } from "@core/types";
import { useCartData } from "../../../../../providers/cartDataStore";
import { useProductCardActions } from "../../../../../providers/useProductActions";

interface CartButtonProps {
  product: Product;
}

const cx = classNames.bind(styles);

export const CartButton = ({ product }: CartButtonProps) => {
  const { cartProductsMap } = useCartData();
  const { addToCart, showProductDetail, removeProductFromCart } = useProductCardActions();

  const cartQuantity = cartProductsMap[product.id]?.quantity ?? 0;

  const handleAddToCart = (e: React.MouseEvent<HTMLIonColElement>) => {
    e.stopPropagation();
    if (product.type === ProductType.VARIABLE) {
      showProductDetail(product.id);
      return;
    }
    addToCart(product);
  };

  const handleRemoveFromCart = (e: React.MouseEvent<HTMLIonColElement>) => {
    e.stopPropagation();
    removeProductFromCart(product.id);
  };

  return (
    <IonGrid className={cx("flex items-center justify-center ion-no-padding")}>
      {!cartQuantity ? (
        <IonCol
          onClick={handleAddToCart}
          className={cx("ion-text-end ion-no-padding cursor-pointer flex items-center justify-end")}
        >
          <IonIcon
            icon={basketOutline}
            className={cx("icon", "ion-text-end center ion-no-padding", {
              disabled: !product?.purchasable,
            })}
          />
        </IonCol>
      ) : (
        <IonRow className={cx("product-card-counter")} onClick={(e) => e.stopPropagation()}>
          <div className={cx("product-card-background", "cursor-pointer")}>
            <IonCol onClick={handleRemoveFromCart} className={cx("iconBackground")}>
              {product.stockStatus === "instock" && <IonIcon className={cx("counter-button")} icon={removeOutline} />}
            </IonCol>
            <IonCol className={cx("quantityCounterFortime")}>
              <IonLabel>{cartQuantity}</IonLabel>
            </IonCol>
            <IonCol onClick={handleAddToCart} className={cx("iconBackground")}>
              {product.stockStatus === "instock" && product.stockQuantity > cartQuantity && (
                <IonIcon className={cx("counter-button")} icon={addOutline} />
              )}
            </IonCol>
          </div>
        </IonRow>
      )}
    </IonGrid>
  );
};
